import { useResolve } from '@visiba/instantiation';
import { usePresentation } from '@visiba/presentation';
import { CasesCollection, VisitsController } from './view_patient_cases.controller';
import { useParams } from 'react-router';
import { CaseList } from './_case_list.component';
import { AppointmentCaseModel } from '@feature/cases/case_appointment_model';
import { MessagingCaseModel } from '@feature/cases/case_messaging_model';

export function ActivatedTab(props: { tab: 'tab1' | 'tab2' }) {
	const controller = useResolve(VisitsController);
	const state = usePresentation(controller.presentation);
	const caseCollection = props.tab === 'tab1' ? state.ongoingCases : state.completedCases;

	const selectedCase = useSelectedCase(caseCollection);

	return <CaseList caseCollection={caseCollection} selectedCase={selectedCase} value={props.tab} />;
}

function useSelectedCase(caseCollection: Nullable<CasesCollection>) {
	const { '*': wildcard } = useParams();
	const [type, identifier] = (wildcard ?? '').split('/');
	let caseModel: AppointmentCaseModel | MessagingCaseModel | undefined = undefined;
	if (type === 'video') {
		caseModel = caseCollection?.appointmentCases.find((appointmentCase) => appointmentCase.get().ticket === identifier);
	} else if (type === 'message') {
		caseModel = caseCollection?.messagingCases.find((messageCase) => messageCase.get().id === identifier);
	}

	return caseModel;
}
